module.exports = __webpack_public_path__ + "img/useradmin-icon.57a01a7e.svg";